export default __webpack_public_path__ + "static/media/challenge.d8614cbc.svg";